module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/node_modules/jsonpath/index.js
// module id = ../../../../jsonpath/index.js
// module chunks = vendor